import Vue from "vue";
import App from "@/App.vue";
import router from "@/routes";
import store from "@/stores";
import configuration from "@/configuration";
import "@/mixins/axios";
import "@/mixins/env";
import "@/directives/mask";
import "@/utils/inactiveMonitor";
import EventBus from "@/utils/global-events.js";
import VueClipboard from "vue-clipboard2";
import "@/configuration/registerBaseComponents";
import VueFormulate from "@braid/vue-formulate";
import S3UploaderPlugin from "@/plugins/s3-uploader-plugin";

Vue.config.productionTip = false;
Vue.use(VueClipboard);
Vue.prototype.EventBus = EventBus;
Vue.use(VueFormulate, {
  plugins: [S3UploaderPlugin],
});

configuration.init().then(() => {
  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount("#app");
});
